import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { ref, onMounted, useTemplateRef } from 'vue';
import DrawerPanel from './DrawerPanel.vue';
import MGWalkthrough from './MGWalkthrough.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'WalkthroughDrawerPanel',
    props: {
        walkthroughData: {},
        slideKey: {}
    },
    emits: ["drawer-opened", "drawer-closed", "action-clicked"],
    setup(__props, { expose: __expose, emit: __emit }) {
        const emit = __emit;
        const walkthroughTitle = ref('');
        const openHeight = ref('90%');
        const walkthroughDrawer = useTemplateRef('walkthrough-drawer');
        function openDrawer() {
            walkthroughDrawer.value?.openDrawer();
        }
        function closeDrawer() {
            document.body.classList.remove('hide-nav-bar');
            walkthroughDrawer.value?.closeDrawer();
        }
        function handleActionClicked(actionUri) {
            emit('action-clicked', actionUri);
            closeDrawer();
        }
        function handleTitleLoaded(title) {
            walkthroughTitle.value = title;
        }
        function handleDrawerOpened() {
            document.body.classList.add('hide-nav-bar');
            emit('drawer-opened');
        }
        function handleDrawerClosed() {
            document.body.classList.remove('hide-nav-bar');
            emit('drawer-closed');
        }
        function determineCarouselHeight() {
            if (window.innerHeight < 700) {
                return '150px';
            }
            else {
                return '240px';
            }
        }
        __expose({ openDrawer, closeDrawer });
        onMounted(() => {
            if (window.innerHeight < 700) {
                openHeight.value = '100%';
            }
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(DrawerPanel, {
                ref: "walkthrough-drawer",
                title: walkthroughTitle.value,
                bottom: "-95px",
                blurBackground: true,
                closeBackground: false,
                openHeight: openHeight.value,
                closedHeight: "0px",
                startOpened: false,
                divider: false,
                contentAlwaysVisible: true,
                backgroundColor: "#FFFFFF",
                openBackgroundColor: "#FFFFFF",
                transitionDuration: ".5s",
                onOpened: handleDrawerOpened,
                onClosed: handleDrawerClosed
            }, {
                default: _withCtx(() => [
                    _createVNode(MGWalkthrough, {
                        walkthroughData: _ctx.walkthroughData,
                        variant: "sheet",
                        slideKey: _ctx.slideKey,
                        dotsAbove: false,
                        height: determineCarouselHeight(),
                        onSlideTitleChanged: handleTitleLoaded,
                        onClose: closeDrawer,
                        onActionClicked: handleActionClicked,
                        onCloseDrawer: closeDrawer
                    }, null, 8, ["walkthroughData", "slideKey", "height"])
                ]),
                _: 1
            }, 8, ["title", "openHeight"]));
        };
    }
});
